import { EMAIL_REPORTS_HAS_ERROR, EMAIL_REPORTS_IS_LOADING,
     EMAIL_REPORTS_FETCH_DATA_SUCCESS, ADD_EMAIL_REPORTS_SUCCESS, EDIT_EMAIL_REPORTS_SUCCESS,
     DELETE_EMAIL_REPORTS_SUCCESS} from '../actions/emailreports'

   
export function emailReportsHasError(state = null, action) {
    switch (action.type) {
        case EMAIL_REPORTS_HAS_ERROR:
            return action.error;

        default:
            return state;
    }
}

export function emailReportsIsLoading(state = false, action) {
    switch (action.type) {
        case EMAIL_REPORTS_IS_LOADING:
            return action.isLoading;

        default:
            return state;
    }
}

export function emailreports(state = [], action) {
    switch (action.type) {
        case EMAIL_REPORTS_FETCH_DATA_SUCCESS:
            return action.reports;

        case ADD_EMAIL_REPORTS_SUCCESS:
            return [action.report, ...state];

        case EDIT_EMAIL_REPORTS_SUCCESS:
            return state.map(function(item) { 
                if (action.report.id === item.id)
                {
                    return action.report;    
                }
                else
                {
                    return item;
                }
            });

        case DELETE_EMAIL_REPORTS_SUCCESS:
            return state.filter(function(item) { 
                return !action.deleted_reports.includes(item.id); 
            });
    
        default:
            return state;
    }
}